export default __webpack_public_path__ + "static/media/baked-chessy-pasta.9bbe25fa.png";